var React = require('react');

function Close (props) {
    return React.createElement("svg",props,[React.createElement("path",{"id":"Path_5","d":"M19.979,0,0,19.581","transform":"translate(0.731 0.746)","fill":"currentColor","key":0}),React.createElement("path",{"id":"Path_5_-_Outline","d":"M1.113,20.717-.35,19.224,19.629-.357l1.463,1.492Z","transform":"translate(0.35 0.357)","fill":"currentColor","key":1}),React.createElement("path",{"id":"Path_6","d":"M0,0,19.979,19.581","transform":"translate(0.731 0.746)","fill":"currentColor","key":2}),React.createElement("path",{"id":"Path_6_-_Outline","d":"M19.629,20.717-.35,1.135,1.113-.357,21.092,19.224Z","transform":"translate(0.35 0.357)","fill":"currentColor","key":3})]);
}

Close.defaultProps = {"width":"21.442","height":"21.074","viewBox":"0 0 21.442 21.074"};

module.exports = Close;

Close.default = Close;
